import { jsx as h, jsxs as e } from "react/jsx-runtime";
const d = (a) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    "aria-hidden": "true",
    ...a,
    children: /* @__PURE__ */ e("g", { fill: "currentColor", children: [
      /* @__PURE__ */ h(
        "path",
        {
          fillRule: "evenodd",
          d: "M14.25 4.31v2.44h2.44l-2.44-2.44Zm4.78 2.66-5-5 5.163 5.243-5.164-5.245a.748.748 0 0 0-.529-.218h-8a.75.75 0 0 0 0 1.5h7.25V7.5c0 .414.336.75.75.75h4.25v12.5H6.25V5.5a.75.75 0 0 0-1.5 0v16c0 .414.336.75.75.75h13a.75.75 0 0 0 .75-.75v-14a.747.747 0 0 0-.22-.53ZM8 13.25a.75.75 0 0 1 0-1.5h1a.75.75 0 0 1 0 1.5H8Zm-.75 3.25c0 .414.336.75.75.75h1a.75.75 0 0 0 0-1.5H8a.75.75 0 0 0-.75.75ZM11 13.25a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 0 1.5h-5Zm-.75 3.25c0 .414.336.75.75.75h5a.75.75 0 0 0 0-1.5h-5a.75.75 0 0 0-.75.75Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          fillRule: "evenodd",
          d: "m19.03 6.97-5-5 5.163 5.243-5.164-5.245a.748.748 0 0 0-.529-.218h-8a.75.75 0 0 0 0 1.5h7.25V7.5c0 .414.336.75.75.75h4.25v12.5H6.25V5.5a.75.75 0 0 0-1.5 0v16c0 .414.336.75.75.75h13a.75.75 0 0 0 .75-.75v-14a.747.747 0 0 0-.22-.53Zm-4.78-2.66v2.44h2.44l-2.44-2.44Z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ h("path", { d: "M8 13.25a.75.75 0 0 1 0-1.5h1a.75.75 0 0 1 0 1.5H8ZM7.25 16.5c0 .414.336.75.75.75h1a.75.75 0 0 0 0-1.5H8a.75.75 0 0 0-.75.75ZM11 13.25a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 0 1.5h-5ZM10.25 16.5c0 .414.336.75.75.75h5a.75.75 0 0 0 0-1.5h-5a.75.75 0 0 0-.75.75Z" })
    ] })
  }
);
export {
  d as IconFile
};
